exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.open-cashier-transfer[data-v-26417a56] {\n  height: 0;\n}\n", ""]);

// exports
